<template>
  <div class="animated fadeIn">
    <h3>Aktörer</h3>
    <div class="card">      
      <div class="card-body">     
        <queryviewlistdetail
          qvtype="Party"
          title="Aktörinformation" 
          :selectable="true"
          :currentkey="id"
          v-on:rowclicked="onclick"
          v-on:currentkeychanged="onclick"
          v-on:iconhover="onhover"
          v-on:iconunhover="onunhover"          
          :detailsvisible="showPartyModal"          
        >
        <template v-slot:details>
          <partydetails v-if="currPartyId" v-bind:partyid="currPartyId" @input="partyChanged"></partydetails>
        </template>
      </queryviewlistdetail>
      </div>

      <!-- <b-modal
        title="Aktörinformation"
        v-model="showPartyModal"
        @ok="showPartyModal = false"
        size="xl"
      >
        <partydetails v-if="currentParty"
          v-bind:party="currentParty"
          @input="partyChanged"
        ></partydetails>
      </b-modal> -->


    </div>
  </div>
</template>

<script>
import queryviewlistdetail from "./../queryview/queryviewlistdetail";
import partydetails from "./partydetails";
import { Api } from "../../lib/api";

const api = new Api();

export default {
  name: "partylist",
  components: { queryviewlistdetail, partydetails },
  data() {
    return {
      id: 0,
      showPartyModal: false,
      //currentParty: {},
      currPartyId:null,
      hoverJob: {},
      showHoverJob: false,
    };
  },
  methods: {
    onclick(row) {
      //alert(row._key);
      this.id = row._key;
      this.setCurrentParty();
    },
    setCurrentParty() {
      this.showPartyModal = true;
      this.currPartyId=this.id;
      //this.currentParty = null;
      // api.get("/api/party/GetDetails?id=" + this.id).then((res) => {
      //   this.currentParty = res.data;
      // });
    },
    onhover(v) {
      console.log(v);

      var id = v.row._key;
      this.showHoverJob = true;
      var xPosition = v.ev.fromElement.offsetLeft + v.ev.clientX + 100;
      var yPosition = v.ev.fromElement.offsetTop; // + v.ev.clientY;
      api.get("/api/ApiJob/GetDetails?id=" + id).then((res) => {
        this.hoverJob = res.data;
        var crd = document.getElementById("hoverInfo");
        crd.style.left = xPosition + "px";
        crd.style.top = yPosition + "px";
      });
    },
    onunhover(v) {
      console.log("UnHover" + v);
      this.hoverJob = {};
      this.showHoverJob = false;
    },
    partyChanged(p) {
      if (this.showPartyModal) this.setCurrentParty();
    },
  },
};
</script>
